import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { RawCollection } from '../types';
import { isCollectionKimeraError } from '../utils/isCollectionKimeraError';

interface CollectionsResponse {
    collections: RawCollection[];
}

export const getCollections = async (): Promise<RawCollection[]> => {
    try {
        const response = await axios.get<CollectionsResponse>(pathfinder('collection_list'));

        return response.data?.collections ?? [];
    } catch (error) {
        if (!isCollectionKimeraError(error)) {
            logger.error(error as Error, { description: 'Failed to fetch collections.' });
        }
        throw error;
    }
};
